export const SOCIAL_MEDIA_TYPES = [
  "youtube",
  "instagram",
  "twitter",
  "facebook",
  "tiktok",
  "linkedin",
] as const;

export const MAX_TWITTER_PAGES = 500;

export const HIDE_SOCIAL_PAGE_COUNT_BADGE = true;
